import React from 'react';
import Navbar from '../layout/Navbar';
import MovementCoachingSection from './MovementCoachingSection';
import ContactSection from '../home/ContactSection';
import Footer from '../layout/Footer';
import GlobalStyles from '../layout/GlobalStyles';

const MovementCoachingPage = () => {
  return (
    <>
      <GlobalStyles />
      <Navbar />
      <MovementCoachingSection />
      <ContactSection />
      <Footer />
    </>
  );
};

export default MovementCoachingPage;